<span class="label">{{ label }}<i *ngIf="labelIcon" class="ml-2 pi {{ labelIcon }}"></i></span>

<div class="content">
  <ng-content></ng-content>
</div>
